<div class="row justify-content-md-center no-gutters greyBgBody text-center marL10">
    <app-loader-icon *ngIf="showLoader"></app-loader-icon>  
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 additionalQuestionSection whiteBg">
                <h5 class="sectionTitleBig">Additional Questions Report</h5>
                <div class="col-5 display_inlineBlock">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <select class="form-control custom-select" id="select-" name="" (change)="onChangeSet($event)" [(ngModel)]="selectedSet">
                          <option value="0">Please choose SET</option>

                          <ng-container *ngFor="let item of setData">
                            <option *ngIf="item.ID != 10 && item.ID != 15" value={{item.ID}}>{{(item.Name + ' ( ' + (item.StartDate) + ' - ' + (item.EndDate) + ' )')}}</option>
                            <option *ngIf="item.Name == 'Business Chemistry and influence 2'" value={{item.ID}}>{{(item.Name + ' ( ' + '03/27/22 - 04/10/22; 07/25/22 - 08/15/22' + ' )')}}</option>
                            <option *ngIf="item.ID == 10" value={{item.ID}}>{{(item.Name + ' ( ' + '03/03/20 - 09/03/20; 11/24/22 - 01/20/23' + ' )')}}</option>
                          </ng-container>
                        </select>
                        <i class="fa fa-chevron-down"></i>

                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="displayVersionField">
                    <div class="col-12">
                      <div class="form-group">
                        <select class="form-control custom-select" id="select-version" name="select-version" [(ngModel)]="selectedVersion">
                          <option value="0" disabled>Select Report Version</option>
                          <option value="1">Version 1</option>
                          <option value="2">Version 2</option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="form-control dateField" placeholder="mm-dd-yyyy"
                                 ngbDatepicker #d="ngbDatepicker" (blur)="fromdateformatcheck(selectedFromDate)" (dateSelect)="onFromDateChange()" [(ngModel)]="selectedFromDate" name="report1" dateFormat="mm-dd-yyyy">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="form-control dateField" placeholder="mm-dd-yyyy"
                                 ngbDatepicker #d1="ngbDatepicker"  (blur)="todateformatcheck(selectedToDate)" (dateSelect)="onToDateChange()" [(ngModel)]="selectedToDate" name="report2" dateFormat="mm-dd-yyyy">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="validateSet" [style.color]="'red'">Please choose set.</div>
                <div *ngIf="validateFromDate" [style.color]="'red'">Please select From Date.</div>
                <div *ngIf="validateToDate" [style.color]="'red'">Please select To Date.</div>

                <div *ngIf="validateDate" [style.color]="'red'">To Date should be greater than or equal to From Date.</div>
                <div *ngIf="validateVersion" [style.color]="'red'">Please select Version</div>

                <div class="">
                    <button type="button"  (click)="onReportBtnClick('Summary')" class="clickBtn">Summary Report</button>
                    <button type="button"  (click)="onReportBtnClick('Detailed')" class="clickBtn marL20">Detailed Report</button>
                </div>


            </div>
        </div>
    </div>
</div>
